export default "__VITE_ASSET__CF_D8aaP__"